import Immutable from "immutable";

const initialState = Immutable.fromJS({
  saleId: null,
  articleIds: []
});

// ------------------------------------
// Reducer
// ------------------------------------
const handlers = {};

const reducer = (moduleState = initialState, action) => {
  const handler = handlers[action.type];

  return Immutable.fromJS(handler ? handler(moduleState, action) : moduleState);
};

export default reducer;

// ------------------------------------
// Selectors / Actions / Handlers
// ------------------------------------
const SET_SALE_ID = `Cart/SET_SALE_ID`;

export const getCartSaleId = moduleState => {
  return moduleState.get("saleId");
};

export const setCartSale = sale => ({
  type: SET_SALE_ID,
  payload: sale
});

handlers[SET_SALE_ID] = (moduleState, { payload: nextSaleId }) => {
  return moduleState.set("saleId", nextSaleId);
};

const PUSH_ARTICLE_ID = `Cart/PUSH_ARTICLE_ID`;
const REMOVE_ARTICLE_ID = `Cart/REMOVE_ARTICLE_ID`;
const SET_ARTICLE_LIST = `Cart/SET_ARTICLE_LIST`;

export const getCartArticleIds = moduleState => {
  return moduleState.get("articleIds");
};

export const pushCartArticle = article => ({
  type: PUSH_ARTICLE_ID,
  payload: article
});

export const removeCartArticle = article => ({
  type: REMOVE_ARTICLE_ID,
  payload: article
});

export const setCartArticleList = articles => ({
  type: SET_ARTICLE_LIST,
  payload: articles
});

handlers[PUSH_ARTICLE_ID] = (moduleState, { payload: nextArticle }) => {
  return moduleState.updateIn(["articleIds"], articleIds => articleIds.push(nextArticle.get("@id")));
};

handlers[REMOVE_ARTICLE_ID] = (moduleState, { payload: articleId }) => {
  const indexValue = moduleState.get("articleIds").indexOf(articleId);
  return moduleState.updateIn(["articleIds"], articleIds => articleIds.delete(indexValue));
};

handlers[SET_ARTICLE_LIST] = (moduleState, { payload: nextArticleList }) => {
  return moduleState.set("articleIds", nextArticleList);
};



// WEBPACK FOOTER //
// ./src/app/redux/modules/cart.js